import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import {
  GET_PROGRAM_MEMBERSHIPS_SUMMARY,
  GET_PROGRAM_MEMBERSHIPS_SUMMARY_ERROR,
  GET_PROGRAM_MEMBERSHIPS_SUMMARY_SUCCESS,
} from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getProgramMembershipsSummary({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/memberships/summary`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.params,
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAM_MEMBERSHIPS_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAM_MEMBERSHIPS_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAM_MEMBERSHIPS_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetProgramMembershipsSummary() {
  yield takeEvery(GET_PROGRAM_MEMBERSHIPS_SUMMARY, getProgramMembershipsSummary);
}

function* getProgramMembershipsSummarySaga() {
  yield all([fork(watchGetProgramMembershipsSummary)]);
}

export default getProgramMembershipsSummarySaga;
